
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/r/[[...ref]]",
      function () {
        return require("private-next-pages/r/[[...ref]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/r/[[...ref]]"])
      });
    }
  